// @flow

import {
  BILLING_OP_TREE,
} from '../constants'

export default (state: Object): Object => state[BILLING_OP_TREE] ? state[BILLING_OP_TREE].billingInfoOperation : {}
